import { useQuery } from '@tanstack/react-query'

import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { AiChatApi } from 'src/services/aiChatApi'

import { UseGetCreditsQueryParams } from './interfaces/useGetCreditsQuery.interface'

export const useGetCreditsQuery = ({
  enabled = true,
}: UseGetCreditsQueryParams = {}) => {
  return useQuery({
    enabled,
    queryFn: () => AiChatApi.getCredits(),
    queryKey: [QueryKey.GET_CREDITS],
  })
}
